export enum StatusEnum {
	Expired = 'vtmn-border-border-negative vtmn-text-content-negative',
	Warning = 'vtmn-border-border-warning vtmn-text-content-warning',
	Updated = 'vtmn-text-content-primary'
}
